import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { PaymentProvider } from './paymentprovider.model';


@Injectable({
  providedIn: 'root'
})
export class PaymentproviderService {



  constructor(private http: HttpClient, private global: Globle, private localStorage: LocalStorageService) {


  }


  getAll(status: number) {
    return this.http.get<PaymentProvider[]>(this.global.APIURL + "paymentproviders?status=" + status);
  }

  getById(id: number) {
    return this.http.get<PaymentProvider>(this.global.APIURL + "paymentproviders/" + id);
  }

  Create(category: object) {
    return this.http.post(this.global.APIURL + "paymentproviders", category)
  }

  Update(category: any) {
    return this.http.put(this.global.APIURL + "paymentproviders", category)
  }

  Delete(id: number) {
    return this.http.delete(this.global.APIURL + "paymentproviders/" + id)
  }

  upload(formdata: any) {
    return this.http.post<any>(this.global.APIURL + "paymentproviders/upload", formdata)
  }
}
